import { Facts } from "../components/Facts";
import { PageFrame } from "../components/PageFrame";
import { Reveal } from "../components/Reveal";
import { assets, aboutParagraphs } from "../content/siteContent";

export function AboutPage() {
  return (
    <PageFrame
      className="about-page"
      label="ΑΣΟ ΩΜΕΓΑ"
      title="Ο Σύλλογος"
      intro={<p>{aboutParagraphs[0]}</p>}
    >
      <Reveal className="about-story technical-frame">
        <div className="about-story-image">
          <img src={assets.editorial} alt="Αθλητικός εξοπλισμός σκοποβολής για ασφαλή προπόνηση" />
          <span className="media-blur-edge" aria-hidden="true" />
        </div>
        <div className="about-story-copy">
          {aboutParagraphs.slice(1).map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </Reveal>
      <Reveal className="about-facts technical-frame">
        <Facts />
      </Reveal>
    </PageFrame>
  );
}
